var PHONE = ['+91 78297 60981']
var EMAIL = 'hello@studiogritt.com'

var config = {
  meta_title: 'Studio Gritt',
  meta_description: 'Studio gritt is a multi-disciplinary design studio.',

  // Required info for schema
  email: EMAIL,
  logo: 'https://studiogritt.files.wordpress.com/2018/04/logod12x-1.png',
  name: 'Studio Gritt',
  legal_name: 'Studio Gritt',
  url: 'https://studiogritt.com',
  phone: PHONE.join('-'),

  // Required address object for schema
  address: {
    street: ' 5th Floor, 439, 18th Main, Koramangala 6th Block',
    city: 'Bangalore',
    state: 'Karnataka',
    zipcode: '560095',
    directions: '',
    country: 'India',
    area: '',
  },

  // Useful adds
  mailto: `mailto:` + EMAIL,
  tel: 'tel:' + PHONE.join(''),

  // Social Media
  googlePlus: 'https://plus.google.com',
  medium: 'https://medium.com',
  facebook: 'https://facebook.com/studiogrittindia',
  twitter: 'https://twitter.com',
  twitter_id: 'studiogritt',

  // Analytics codes
  googleAnalytics: 'UA-118305972-1',

  // Font codes
  typekit: '',
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config.js